import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StatoVideoperizia } from '../models/stato-videoperizia';
import { ResourcefulService } from './resourcefulService';



@Injectable({
  providedIn: 'root'
})
export class StatoVideoperiziaService extends ResourcefulService<StatoVideoperizia>{
  constructor(private httpClient: HttpClient) {
    super(httpClient, StatoVideoperizia);
  }
}
